/**
 * @generated SignedSource<<a21dad06ec064c2a561b8c3bb4c64870>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorHeaderAuthor$data = {
  readonly areaOfExpertise: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly bio: string | null | undefined;
  readonly education: string | null | undefined;
  readonly entityId: string;
  readonly languageSpoken: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly location: string | null | undefined;
  readonly name: string;
  readonly role: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly socialLinks: ReadonlyArray<{
    readonly class: string | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "authorSocialLinksAuthor" | "entityFollowButtonBase">;
  readonly " $fragmentType": "authorHeaderAuthor";
};
export type authorHeaderAuthor$key = {
  readonly " $data"?: authorHeaderAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorHeaderAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorHeaderAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SocialLink",
      "kind": "LinkedField",
      "name": "socialLinks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "class",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "education",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areaOfExpertise",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageSpoken",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorAvatarAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorSocialLinksAuthor"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "af341fe8c3cffb18e9cfe16c02f51f72";

export default node;
